import axios from 'axios'
export default ({
    state:{
        /* CONTROLE DE AUTENTICAÇÃO */
        tenant: {},
        user: {},
    },
    getters: {},
    mutations:{
        /*=============================================================================
        * setTenant 
        * Controla Serial Number e nome do cliente para acesso a aplicação  
        =============================================================================*/
        setTenant(state, payload) {
            state.tenant = payload          
        },

        /*=============================================================================
        * setUser 
        * Controla o estado de Autenticação do Ususário na Aplicação definindo o TOKEN
        * a ser utilizado pelo AXIOS para controle de acesso ao Data Base    
        =============================================================================*/
        setUser(state, user) {
            /* Deletando Keys não utilizadas */    
            delete user.place;
            delete user.secret_key
            delete axios.defaults.headers.common['sn']
            state.user = user
            if(user) {
                axios.defaults.headers.common['Authorization'] = user.Authorization
                axios.defaults.headers.common['sn'] = state.tenant.serial_number
            } else {
                delete axios.defaults.headers.common['Authorization']
            }
        },
    }
})
